var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition-group',{attrs:{"name":"fade","tag":"div"}},_vm._l(([_vm.currentIndex]),function(i){return _c('div',{key:i,staticClass:"imageborder"},[_c('img',{attrs:{"src":_vm.currentImg},on:{"click":_vm.next}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }